// Phone validation: just checks non-empty, assumes formatting handled via input
export const isValidPhone = (number) => /^\+\d{1,4}\d{6,14}$/.test(number);

// Pincode validation (optional but if filled, must be exactly 6 digits)
export const isValidPincode = (pincode) =>
  pincode === '' || /^[1-9][0-9]{5}$/.test(pincode);

// GSTIN validation (optional but if filled, must follow format)
export const isValidGSTIN = (gstin) =>
  gstin === '' || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/.test(gstin.toUpperCase());

// PAN validation (optional but if filled, must follow format: AAAAA9999A)
export const isValidPAN = (pan) =>
  pan === '' || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan.toUpperCase());
